import {IntermediatePart} from "../../intermediatePart";

export default class TopHandle extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'top_handle';
    this.partName = 'Top Handle';
    this.translateId = "visualizer.kitchen.cabinet.top_handle";
    this.hasAdditionalParts = true;
    this.canBeDisabled = true;
  }

}
